// @flow
import * as React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { IconButton } from 'gestalt';

type PinHoverClickThroughAffordanceIconProps = {|
  pinId: string,
  sourceUrl: string,
  domain: string,
  onClick: () => void,
  bgColor: 'white' | 'transparent' | 'transparentDarkGray',
  iconColor: 'white' | 'darkGray',
  size: 'sm' | 'md',
|};

const PinHoverClickThroughAffordanceIcon = ({
  pinId,
  sourceUrl,
  domain,
  onClick,
  bgColor,
  size,
  iconColor,
}: PinHoverClickThroughAffordanceIconProps) => {
  if (!sourceUrl) {
    return null;
  }

  return (
    <NavigateLink external onClick={onClick} pinId={pinId} stopPropagation to={sourceUrl}>
      <IconButton
        bgColor={bgColor}
        icon="arrow-up-right"
        // NOTE: using domain for accessibilityLabel to get title tooltip hover
        accessibilityLabel={domain}
        size={size}
        iconColor={iconColor}
      />
    </NavigateLink>
  );
};

export default PinHoverClickThroughAffordanceIcon;
